export var isBreakPointValueMap = function (possibleMap) {
    return !Array.isArray(possibleMap) && typeof possibleMap === 'object';
};
export var isBreakPointValueArray = function (possibleMap) {
    return Array.isArray(possibleMap);
};
export var mapResponsiveStyleValue = function (propValue, getStyleValueForPropValue) {
    if (isBreakPointValueArray(propValue)) {
        return propValue.map(function (propValueItem) { return getStyleValueForPropValue(propValueItem); });
    }
    if (isBreakPointValueMap(propValue)) {
        return Object.keys(propValue).reduce(function (acc, key) {
            acc[key] = getStyleValueForPropValue(propValue[key]);
            return acc;
        }, {});
    }
    return getStyleValueForPropValue(propValue);
};
